import { RegistryWidgetsType } from '@rjsf/utils';

import { customFieldWidgetTypes } from 'shared/constants';

import WidgetInput from './WidgetInput';
import WidgetMultiselect from './WidgetMultiselect';
import { WidgetTipTap } from './WidgetTipTap';
import WidgetSkillsTaxonomy from './WidgetSkillsTaxonomy';
import WidgetStars from './WidgetStars';
import WidgetTotal from './WidgetTotal';
import WidgetBinaryToggleInteger from './WidgetBinaryToggleInteger';

export const widgets = {
  [customFieldWidgetTypes.input]: WidgetInput,
  [customFieldWidgetTypes.multiselect]: WidgetMultiselect,
  [customFieldWidgetTypes.rte]: WidgetTipTap,
  [customFieldWidgetTypes.skillsTaxonomy]: WidgetSkillsTaxonomy,
  [customFieldWidgetTypes.stars]: WidgetStars,
  [customFieldWidgetTypes.total]: WidgetTotal,
  [customFieldWidgetTypes.binaryToggleInteger]: WidgetBinaryToggleInteger,
} as RegistryWidgetsType<any, any, any>;
